import type { ColDef } from 'ag-grid-community';
import { ClientCellEditor, ClientCellRenderer } from 'components/shared/Blotter/Grid/CellRenderers/ClientCellEditor';
import { editableContentCellRendererFactory } from 'components/shared/Blotter/Grid/CellRenderers/EditableContentCellRenderer';
import { useMemo } from 'react';
import { getEditInfoForProductField } from 'state/secondaryMarket/productSearch/productSearch.selectors';

export function useEditableClientColumnType(): ColDef {
  return useMemo(
    () => ({
      cellEditor: ClientCellEditor,
      cellRenderer: editableContentCellRendererFactory(getEditInfoForProductField, ClientCellRenderer),
    }),
    [],
  );
}
